export const CREATE_PANEL_VISUALIZATIONS_SUBSCRIPTION =
  'dt/visualizations/CREATE_PANEL_VISUALIZATIONS_SUBSCRIPTION';
export const DESTROY_PANEL_VISUALIZATIONS_SUBSCRIPTION =
  'dt/visualizations/DESTROY_PANEL_VISUALIZATIONS_SUBSCRIPTION';
export const DESTROY_VISUALIZATIONS_SUBSCRIPTION =
  'dt/visualizations/DESTROY_VISUALIZATIONS_SUBSCRIPTION';
export const GET_SINGLE_VISUALIZATION_DATA = 'dt/visualizations/GET_SINGLE_VISUALIZATION_DATA';
export const BULK_UPSERT_VISUALIZATION = 'dt/visualizations/BULK_UPSERT_VISUALIZATION';
export const UPSERT_VISUALIZATION = 'dt/visualizations/UPSERT_VISUALIZATION';
export const REQUEST_DELETE_VISUALIZATION = 'dt/visualizations/REQUEST_DELETE_VISUALIZATION';
export const DELETE_VISUALIZATION_SUCCESS = 'dt/visualizations/DELETE_VISUALIZATION_SUCCESS';
export const REQUEST_VISUALIZATIONS = 'dt/visualizations/REQUEST_VISUALIZATIONS';
export const RECEIVE_VISUALIZATION = 'dt/visualizations/RECEIVE_VISUALIZATION';
export const RECEIVE_VISUALIZATIONS = 'dt/visualizations/RECEIVE_VISUALIZATIONS';
export const SAVE_VISUALIZATION = 'dt/visualizations/SAVE_VISUALIZATION';
export const RECEIVED_VALUES = 'dt/visualizations/RECEIVED_VALUES';
export const INIT_VISUALIZATIONS = 'dt/visualizations/INIT_VISUALIZATIONS';
export const RESET_VISUALIZATIONS = 'dt/visualizations/RESET_VISUALIZATIONS';
export const SET_LOADING = 'dt/visualizations/SET_LOADING';
export const EXPORT_VISUALIZATIONS_TEMPLATE = 'dt/visualizations/EXPORT_VISUALIZATIONS_TEMPLATE';
export const UPLOAD_VISUALIZATIONS_EXCEL = 'dt/visualizations/UPLOAD_VISUALIZATIONS_EXCEL';
export const VISUALIZATIONS_IMPORT_ERRORS = 'dt/visualizations/VISUALIZATIONS_IMPORT_ERRORS';
export const VISUALIZATIONS_IMPORTED_AT = 'dt/visualizations/VISUALIZATIONS_IMPORTED_AT';
export const REQUEST_VISUALIZATION_TEMPLATE_TYPES =
  'dt/visualizations/REQUEST_VISUALIZATION_TEMPLATE_TYPES';
export const RECEIVE_VISUALIZATION_TEMPLATE_TYPES =
  'dt/visualizations/RECEIVE_VISUALIZATION_TEMPLATE_TYPES';

export const LAST_VALUE_VISUALIZATIONS = new Set([
  'gauge',
  'metric',
  'bar-gauge',
  'grouped-bar',
  'pie',
  'state',
  'status',
]);

export const getSingleVisualization = (visualization, panelId) => ({
  type: GET_SINGLE_VISUALIZATION_DATA,
  visualization,
  panelId,
});

export const bulkUpsertVisualization = (visualization) => ({
  type: BULK_UPSERT_VISUALIZATION,
  visualization,
});

export const upsertVisualization = (siteId, visualization) => ({
  type: UPSERT_VISUALIZATION,
  siteId,
  visualization,
});

export const saveVisualization = (visualization, parentPanelId) => ({
  type: SAVE_VISUALIZATION,
  visualization,
  parentPanelId,
});

export const requestVisualizations = (siteId) => ({
  type: REQUEST_VISUALIZATIONS,
  siteId,
});

export const requestDeleteVisualization = (visualizationId) => ({
  type: REQUEST_DELETE_VISUALIZATION,
  visualizationId,
});

export const deleteVisualizationSuccess = (visualizationId) => ({
  type: DELETE_VISUALIZATION_SUCCESS,
  visualizationId,
});

export const receiveVisualization = (visualization) => ({
  type: RECEIVE_VISUALIZATION,
  visualization,
});

export const receiveVisualizations = (visualizations, siteId) => ({
  type: RECEIVE_VISUALIZATIONS,
  visualizations,
  siteId,
});

export const subscribePanel = (visualizations, panelId) => ({
  type: CREATE_PANEL_VISUALIZATIONS_SUBSCRIPTION,
  visualizations,
  panelId,
});

export const unsubscribePanel = (visualizations, panelId) => ({
  type: DESTROY_PANEL_VISUALIZATIONS_SUBSCRIPTION,
  visualizations,
  panelId,
});

export const receivedValues = (visualizationId, values, panelId) => {
  const { latestValues, seriesValues } = values;
  return {
    type: RECEIVED_VALUES,
    visualizationId,
    latestValues,
    seriesValues,
    panelId,
  };
};

export const setLoading = (visualizationId, panelId, loading = true) => ({
  type: SET_LOADING,
  visualizationId,
  panelId,
  loading,
});

export const resetVisualizations = () => ({
  type: RESET_VISUALIZATIONS,
});

export const exportVisualizationsTemplate = (
  site,
  templateType,
  sourceId,
  sourceName,
  options = {}
) => ({
  type: EXPORT_VISUALIZATIONS_TEMPLATE,
  site,
  templateType,
  sourceId,
  sourceName,
  options,
});

export const uploadVisualizationsExcel = (file, siteId, org, sourceId) => ({
  type: UPLOAD_VISUALIZATIONS_EXCEL,
  file,
  siteId,
  org,
  sourceId,
});

export const setImportErrors = (errors) => ({
  type: VISUALIZATIONS_IMPORT_ERRORS,
  errors,
});

export const setVisualizationsImportedAt = (importedAt = 0) => ({
  type: VISUALIZATIONS_IMPORTED_AT,
  visualizationsImportedAt: importedAt,
});

export const requestVisualizationTemplateTypes = () => ({
  type: REQUEST_VISUALIZATION_TEMPLATE_TYPES,
});

export const receiveVisualizationTemplateTypes = (templateTypes) => ({
  type: RECEIVE_VISUALIZATION_TEMPLATE_TYPES,
  templateTypes,
});
